import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { usePriceWebSocket } from '../hooks/usePriceWebSocket';

const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
  // Load auto-update preference from localStorage
  const [autoUpdateEnabled, setAutoUpdateEnabled] = useState(() => {
    const saved = localStorage.getItem('krown-auto-update');
    return saved === 'true';
  });

  const { connectionStatus, priceData, recentSwaps, lastUpdate, requestRefresh, isConnected } = usePriceWebSocket(autoUpdateEnabled);

  // Toggle auto-update and save preference
  const toggleAutoUpdate = useCallback(() => {
    setAutoUpdateEnabled(prev => {
      const newValue = !prev;
      localStorage.setItem('krown-auto-update', String(newValue));
      return newValue;
    });
  }, []);

  const value = {
    // Connection state
    connectionStatus,
    isConnected,
    
    // Data
    priceData,
    recentSwaps,
    lastUpdate,
    
    // Auto-update controls
    autoUpdateEnabled,
    toggleAutoUpdate,
    
    // Manual refresh via WebSocket
    requestRefresh,
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocket() {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
}
